import environment from '@lib/environment';

export function isDevelopment() {
  return environment.MODE !== 'production';
}

export function isProduction() {
  return environment.MODE === 'production';
}
